import { keyBy, noop, omitBy } from 'lodash';
import { useMemo } from 'react';

const useEntitiesMenu = ({
  entities,
  currentMenuItem,
  onCloseMenu = noop,
  setKeyword,
  selectedCheckboxes,
  noDataMessage,
  withEntityPayload,
  selectedFilters,
  setSelectedFilters
}) => {
  const isMultiSelectedEntity = currentMenuItem?.multiSelected !== false;

  const selectedMenuHeader =
    currentMenuItem?.header || `Select ${currentMenuItem?.title}`;

  const maxSelected = currentMenuItem?.maxSelected;

  const entitiesById = useMemo(() => keyBy(entities, 'id'), [entities]);

  const closeButton = {
    title: 'Close',
    isClickToCloseMenu: true,
    onClick: () => onCloseMenu(2)
  };

  const addButton = {
    title: 'Add',
    buttonProps: {
      variant: 'default'
    },
    dataCy: 'FilterMenus-addBtn',
    dataTestid: 'FilterMenus-addBtn',
    isClickToCloseAllMenus: true,
    onClick: () => {
      const selectedCheckboxesWithEntities = selectedCheckboxes.map(chkItem => {
        const item = entitiesById[chkItem?.id];
        const entity = item?.entity;
        return {
          ...chkItem,
          ...(entity && { entity })
        };
      });
      const updatedFilters = {
        ...(selectedFilters || {}),
        ...(selectedCheckboxes
          ? {
              [currentMenuItem?.id]: withEntityPayload
                ? selectedCheckboxesWithEntities
                : selectedCheckboxes
            }
          : {})
      };
      const omittedFilters = omitBy(
        updatedFilters,
        values => values?.length === 0
      );
      setSelectedFilters(omittedFilters);
      onCloseMenu(2);
    }
  };

  const singleSelectedMenu = {
    id: 'filterTypeOptions',
    header: selectedMenuHeader,
    isSearchable: true,
    onSearch: setKeyword,
    isMultiple: false,
    actions: [closeButton],
    menuItems: entities
  };

  const multiSelectedMenu = {
    id: 'filterTypeOptions',
    maxSelectedCheckboxes: maxSelected,
    header: maxSelected
      ? `${selectedMenuHeader}/s (${maxSelected} max):`
      : `${selectedMenuHeader}/s:`,
    subheader:
      selectedCheckboxes.length && `(${selectedCheckboxes.length} selected)`,
    onSearch: setKeyword,
    isSearchable: true,
    isMultiple: true,
    selectedCheckboxes,
    noDataMessage,
    actions: [closeButton, entities.length && addButton].filter(Boolean),
    menuItems: entities
  };
  const entitiesMenu = isMultiSelectedEntity
    ? multiSelectedMenu
    : singleSelectedMenu;

  return { entitiesMenu };
};

export default useEntitiesMenu;
